import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { StyledResetButton } from '~/shared/components';
import { breakpoints } from '~/theme';

const COLOR_ITEM_SIZE_DESKTOP = 80;
const COLOR_ITEM_SIZE_MOBILE = 48;

export const StyledContent = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spaces[2],
}));

export const StyledColorVariantList = styled.ul<{ active?: boolean }>(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spaces[2],
}));

export const StyledColorVariant = styled.li<{ active?: boolean }>(
    {
        height: COLOR_ITEM_SIZE_MOBILE,
        width: COLOR_ITEM_SIZE_MOBILE,
        [breakpoints.md]: {
            height: COLOR_ITEM_SIZE_DESKTOP,
            width: COLOR_ITEM_SIZE_DESKTOP,
        },
    },
    ifProp('active', {
        outline: '1px solid',
    })
);

export const StyledMoreButton = styled(StyledResetButton)(({ theme }) => ({
    justifyContent: 'center',
    outline: `1px solid ${theme.colors.dark}`,
    backgroundColor: theme.colors.light30,
    fontSize: theme.fontSizes.lg,
    height: COLOR_ITEM_SIZE_MOBILE,
    width: COLOR_ITEM_SIZE_MOBILE,
    cursor: 'pointer',
    [breakpoints.md]: {
        height: COLOR_ITEM_SIZE_DESKTOP,
        width: COLOR_ITEM_SIZE_DESKTOP,
    },
}));
